/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconBrandPolymer = createReactComponent("brand-polymer", "IconBrandPolymer", [
  [
    "path",
    {
      d: "M6.706 6l-3.706 6l3.706 6h1.059l8.47 -12h1.06l3.705 6l-3.706 6",
      key: "svg-0"
    }
  ]
]);

export { IconBrandPolymer as default };
//# sourceMappingURL=IconBrandPolymer.js.map
